/* Favoritos — Cuadros Splash

   Sin cuenta, sin backend: la lista vive en localStorage, en ESTE navegador.
   Se guardan HANDLES de producto (no ids), porque son estables y bastan para
   pedir la ficha completa a Shopify cuando hace falta —
   /products/<handle>.js, el mismo endpoint público que ya usa el tema para
   el carrito. Ver también assets/favoritos-pagina.js, que es quien hace esa
   petición en /pages/favoritos.

   Tres piezas se apoyan en este fichero:
     1. El corazón de cada tarjeta de producto y de la ficha (data-cs-fav).
     2. El contador del icono de la cabecera (#favoritos-count-bubble).
     3. La página /pages/favoritos.

   Red de seguridad: si localStorage no está disponible (modo privado
   estricto, ajustes del navegador), todo esto se apaga solo — los botones
   se quedan como botones normales que no hacen nada. Nunca un error visible,
   nunca un carrito ni un favorito a medias.
*/

(function () {
  var CLAVE = 'cs_favoritos';

  function hayAlmacen() {
    try {
      var k = '__cs_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }

  var ACTIVO = hayAlmacen();

  function leer() {
    if (!ACTIVO) return [];
    try {
      var datos = JSON.parse(window.localStorage.getItem(CLAVE) || '[]');
      return Array.isArray(datos) ? datos : [];
    } catch (e) {
      return [];
    }
  }

  function guardar(lista) {
    if (!ACTIVO) return;
    try {
      window.localStorage.setItem(CLAVE, JSON.stringify(lista));
      actualizarContador();
      pintarTodos(document);
    } catch (e) {
      /* Almacén lleno o bloqueado a medio uso: no rompemos nada por eso. */
    }
  }

  function esFavorito(handle) {
    return leer().indexOf(handle) !== -1;
  }

  function alternar(handle) {
    var lista = leer();
    var pos = lista.indexOf(handle);
    if (pos === -1) {
      lista.push(handle);
    } else {
      lista.splice(pos, 1);
    }
    guardar(lista);
    return pos === -1; // true si a partir de ahora ES favorito
  }

  function pintarBoton(btn, activo) {
    btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
    btn.classList.toggle('is-fav', activo);
    var txt = btn.querySelector('[data-cs-fav-txt]');
    if (txt) {
      txt.textContent = activo ? txt.dataset.on : txt.dataset.off;
    }
  }

  function pintarTodos(root) {
    var set = {};
    leer().forEach(function (h) {
      set[h] = true;
    });
    (root || document).querySelectorAll('[data-cs-fav]').forEach(function (btn) {
      pintarBoton(btn, !!set[btn.dataset.csFav]);
    });
  }

  function actualizarContador() {
    var n = leer().length;
    var bubble = document.getElementById('favoritos-count-bubble');
    if (!bubble) return;
    var span = bubble.querySelector('[data-count]');
    if (span) span.textContent = n;
    bubble.hidden = n === 0;
  }

  function botonEnElPunto(x, y) {
    // No basta con e.target.closest(): Dawn estira el enlace del título
    // (.card__heading a::after) sobre TODA la tarjeta con su propio
    // z-index, y en la práctica se ha comprobado que ni subir el z-index
    // del botón ni aislarlo con `isolation` consigue ganarle el hit-test
    // — algo en el motor de renderizado lo sigue colocando encima pase lo
    // que pase con la cascada. Por eso aquí no se confía en cuál es
    // e.target: se pregunta directamente qué hay en ESE PUNTO exacto y se
    // busca un botón de favorito entre TODO lo que haya ahí apilado.
    var pila = document.elementsFromPoint(x, y);
    for (var i = 0; i < pila.length; i++) {
      var candidato = pila[i].closest && pila[i].closest('[data-cs-fav]');
      if (candidato) return candidato;
    }
    return null;
  }

  // Fase de CAPTURA, no de burbujeo: tiene que decidirse ANTES de que el
  // navegador procese el enlace estirado y navegue.
  document.addEventListener(
    'click',
    function (e) {
      var btn = botonEnElPunto(e.clientX, e.clientY);
      if (!btn || !btn.dataset.csFav) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.dataset.csFav;
      var ahoraFavorito = alternar(handle);
      // Repinta TODOS los botones de ese mismo producto: puede aparecer en
      // más de una tarjeta a la vez (portada y colección, por ejemplo).
      document.querySelectorAll('[data-cs-fav="' + CSS.escape(handle) + '"]').forEach(function (b) {
        pintarBoton(b, ahoraFavorito);
      });
      actualizarContador();
      document.dispatchEvent(
        new CustomEvent('cs:favoritos-cambio', {
          detail: { handle: handle, favorito: ahoraFavorito },
        })
      );
    },
    true
  );

  function arrancar() {
    pintarTodos(document);
    actualizarContador();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  // El editor de temas puede volver a insertar una sección sin recargar la
  // página: por eso el segundo enganche, mismo patrón que canvas-3d.js y
  // product-gel-finish.js.
  document.addEventListener('shopify:section:load', arrancar);

  // Red de seguridad para cualquier otra reinyección del DOM que no dispare
  // ninguno de los dos eventos de arriba — un filtro de colección, por
  // ejemplo. Solo mira altas/bajas de nodos (childList), así que repintar
  // aquí dentro (que solo toca clases y atributos) nunca se dispara a sí
  // mismo en bucle.
  if ('MutationObserver' in window) {
    var aviso = null;
    var obs = new MutationObserver(function () {
      window.clearTimeout(aviso);
      aviso = window.setTimeout(arrancar, 80);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.csFavoritos = { leer: leer, guardar: guardar, esFavorito: esFavorito };
})();
